<section id="home" [ngStyle]="{backgroundImage:'url(assets/images/background.jpeg)'}"
    class="d-flex flex-column justify-content-center align-items-center">
    <picture>
        <img src="assets/images/mif.jpg" alt="mifdha" class="profile">
    </picture>
    <h1 class="mt-3">Mifdha Milan</h1>
    <div class="hero-container aos-init aos-animate" data-aos="fade-in">
        <p><span class="typed"></span></p>
    </div>
    <mat-card class="card" fxFlex fxLayoutAlign="center center">
        <div class="d-flex flex-row align-content-center" id="overlay">
            <a href="https://github.com/MifdhaMilan"><img src="assets/images/github.png" alt="github"
                    class="img-fluid"></a>
            <a href="https://www.linkedin.com/in/mifdha-milan-7403a5185"><img src="assets/images/linkedin.png"
                    alt="linkedin" class="img-fluid"></a>
            <a href="https://mifdhamilan.medium.com"><img src="assets/images/Medium.png" alt="medium"
                    class="img-fluid"></a>
            <a href="https://www.facebook.com/mifdha.milan"><img src="assets/images/facebook.png" alt="facebook"
                    class="img-fluid"></a>
            <a href="https://stackoverflow.com/users/14620270/mifdha-milan"><img src="assets/images/stackoverflow.png"
                    alt="stackoverflow" class="img-fluid"></a>
            <a href="https://www.hackerrank.com/mifmilan"><img src="assets/images/Hackerrank.png" alt="hackerrank"
                    class="img-fluid"></a>
        </div>
    </mat-card>
</section>